/* unplugin-vue-components disabled */import { render } from "./Commercial.vue?vue&type=template&id=5aefea4e&ts=true"
import script from "./Commercial.vue?vue&type=script&lang=ts"
export * from "./Commercial.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/yaogengzhu/Documents/soft-open/software-platform/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__